import ReactDOM from 'react-dom'

interface LoadingProps {
  backdrop?: boolean;
  show?: boolean;
}

const Loading = ({ backdrop = true, show = true }: LoadingProps) => {
  const backdropClasses = backdrop ? 'fixed inset-0 flex items-center justify-center bg-gray-500 opacity-75 z-50' : ''
  const loadingClasses = show ? 'flex items-center justify-center fixed inset-0 z-50' : 'hidden'

  return ReactDOM.createPortal(
    <>
      {backdrop && <div className={backdropClasses}></div>}
      <div className={loadingClasses}>
        <span className="loading loading-bars loading-lg"></span>
      </div>
    </>,
    document.body // Mount the portal at the top level of the DOM
  )
}

export default Loading